<div class="card mb-4">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-between mb-2">
                    <h3 class="card-title mb-0 align-self-start">Outstanding Invoices</h3>
                    <span class="d-none d-sm-block"
                        [msTooltip]="onlinePaymentsDisabledTooltip"
                        [msTooltipDisabled]="isStripeOnboardingComplete()"
                        [attr.tabindex]="isStripeOnboardingComplete() ? -1 : 0">
                        <button class="btn btn-success btn-width-medium"
                            [disabled]="selectedInvoiceAmount() === 0 || !isStripeOnboardingComplete()"
                            (click)="payCharges()">
                            Pay@if (selectedInvoiceAmount() > 0) { {{ ' ' + (selectedInvoiceAmount() | CurrencyDisplay: currencyType()!) }} }
                        </button>
                    </span>
                </div>
                <ms-property-charge-list
                    #chargeList
                    [currentPropertyChargeListViewLocation]="PropertyChargeListViewLocations.MemberProfilePage"
                    [memberId]="member()?.memberId"
                    (totalSelectedAmountChange)="selectedInvoiceAmount.set($event)"
                    (totalCurrencyChange)="currencyType.set($event)"
                    (payRequested)="payCharges()">
                </ms-property-charge-list>
            </div>
        </div>
    </div>
</div>

<!-- [organizationId] is the member's own organization, not the active one: it decides which
     organization's Stripe account the payment is created against, and a member profile is reachable
     for any organization the viewer belongs to (DEV-2643). -->
<ms-payment-modal
    #paymentModal
    [userId]="userSessionService.activeUser()?.userId!"
    [organizationId]="member()!.organizationId"
    (paymentCompleted)="onPaymentCompleted()">
</ms-payment-modal>
